import { Skeleton, Slot, Anchor } from '@costar-ui/components';
import { IconMail } from '@costar-ui/icons/csg/IconMail';
import React, { useCallback } from 'react';

var MailtoLink = function MailtoLink(props) {
  var email = props.email,
    testId = props.testId,
    isLoading = props.isLoading;
  var stopPropagationOnClick = useCallback(function (e) {
    e.stopPropagation();
  }, []);
  var extractEmail = function extractEmail(input) {
    var emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/;
    var match = emailRegex.exec(input);
    return match ? match[0] : null;
  };
  var emailLinkLabel = email ? extractEmail(email) : null;
  return isLoading ? /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.25",
    className: "csg-tw-skeleton-mail-to-link"
  }) : email && /*#__PURE__*/React.createElement(Slot, {
    gap: "sm",
    className: "csg-tw-contact-email-link h-max",
    testId: testId
  }, /*#__PURE__*/React.createElement(IconMail, {
    size: "1.3rem",
    className: "min-w-5 text-on-base"
  }), /*#__PURE__*/React.createElement(Anchor, {
    variant: "primary-md",
    href: "mailto:".concat(email),
    onClick: stopPropagationOnClick,
    className: "wrap-anywhere",
    testId: "email"
  }, emailLinkLabel));
};

export { MailtoLink };
//# sourceMappingURL=mailto-link.esm.js.map
